import type { Period } from "api";
import { alertRequest, body, request } from "services/request";

const baseUrl = "api/DriverSalary";

const getItem = (params: { period: Period }) => {
    const { year, month } = params.period;

    return request(
        `api/report/getDataQuery/DriverSalaryReport/?paramsQuery=$filter=reportPeriod eq ${year}-${month}-01T00:00:00.000Z`,
        {
            method: "GET",
        },
    );
};

const apply = (params: {}) => {
    return alertRequest(`${baseUrl}/Apply`, body(params));
};

const applyIndividualPrize = (params: {}) => {
    return alertRequest(`${baseUrl}/ApplyIndividualPrize`, body(params));
};

const getOptions = (params: { period: Period }) => {
    const { year, month } = params.period;

    return request(`${baseUrl}/GetOptions?period=${year}-${month}-01T00:00:00.000Z`, { method: "GET" });
};

export { getItem, apply, applyIndividualPrize, getOptions };
